import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=d79c155a&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=js&"
export * from "./InputTextarea.vue?vue&type=script&lang=js&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=d79c155a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d79c155a",
  null
  
)

export default component.exports